import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7 pb-[200px]" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from './FormSection.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const route = useRoute();

const branchId = route.params.id;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Create Block Date",
    "show-back": "",
    backUrl: `/branches/${_unref(branchId)}/blocked-dates`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, { "branch-id": _unref(branchId) }, null, 8, ["branch-id"])
      ])
    ]),
    _: 1
  }, 8, ["backUrl"]))
}
}

})